import React from "react";

import { Link } from "react-router";

import { CrossSellSelectionProps } from "./crossSellSelection.model";
import { useCrossSell } from "@companion-core/shared/app/Components/CrossSell/hooks/useCrossSell";
import { APICrossSell } from "@companion-core/shared/app/Interfaces/API";
import { ContentCard } from "@companion-core/shared/app/Components/Cards/ContentCard";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { serviceIcons } from "@companion-core/shared/app/Constants/myRequests";
import { useBellLink } from "@companion-core/shared/app/Hooks/useBellLink";

export const CrossSellSelection = ({
  family,
  subFamily,
  className,
  requestId,
}: CrossSellSelectionProps) => {
  const { data, isError, t, isLoading } = useCrossSell({ family, subFamily });
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  const { openBellLink } = useBellLink({ platform: "web", bellReferrer: "cross-sell" });
  const renderCrossSellItem = (element: APICrossSell) => {
    const hasSubCrossSell = element?.cross_sell_concierge?.sub_cross_sells?.length > 0;
    const accessibilityLabel = hasSubCrossSell
      ? t("cross-sell.selection.list.cross-sell-group.accessibility.label", {
          title: element?.title,
          subtitle: element?.description,
        })
      : t("cross-sell.selection.list.cross-sell.accessibility.label", {
          title: element?.title,
          subtitle: element?.description,
        });
    const card = (
      <ContentCard
        testID={`cross-sell-selection__list--${element.id}`}
        title={element.title}
        imageUrl={
          element?.medias?.length > 0
            ? getCloudinaryOptimizedUrl(element?.medias[0]?.url, { contentType: "card" })
            : undefined
        }
        imageAlt={element?.medias?.[0]?.description_alt}
        subtitle={element?.description}
        iconOverlay={
          !isMobileSize ? (serviceIcons[element.family] ?? "JP-Concierge-bell") : undefined
        }
      />
    );

    return (
      <li key={element.id}>
        {hasSubCrossSell ? (
          <Link
            aria-label={accessibilityLabel}
            to={`/my-requests/cross-sell/${requestId}/${element.id}`}>
            {card}
          </Link>
        ) : (
          <button
            aria-label={accessibilityLabel}
            type="button"
            onClick={() => openBellLink(element.bell_deep_link)}>
            {card}
          </button>
        )}
      </li>
    );
  };

  return (
    !isLoading &&
    !isError && (
      <section className={`${className ? className + " " : ""}cross-sell-selection`}>
        <h3 className="cross-sell-selection__title title-7">{t("cross-sell.selection.title")}</h3>
        <ol className="cross-sell-selection__list">
          {(data as APICrossSell[])?.map(renderCrossSellItem)}
        </ol>
      </section>
    )
  );
};
